import { Button, Typography,Grid } from "antd";
import React, { useEffect, useState } from "react";
import { formatString } from "../Common/ColorCode";
import moment, { duration } from "moment";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import ClinicMap from "../Dashboard/ClinicMap";
import { capitalizeWords } from "../Common/CommonFunction";
import {capitalizeFirst, filterByNonGpProductId} from "../Common/CommonFunction";
import "../Dashboard/BookingForm.css";
import { ChevronRight, ChevronDown, Phone } from "lucide-react";
import logo from "../../Assets/images/ldc_logo_new.png";
import {originalBooking,newBooking} from "./cancelData"

function CancelationBookingDetails(props) {

  const [tempoldData, setTempOldData] = useState([
  { key: "Duration", data: props?.oldData?.duration }, // or fallback to "15 minutes"
  { key: "Price", data: props?.oldData?.price },
  { key: "Language", data: "English" },
  { key: "Gender", data: "male" },
]);
  const [buttonopen, setButtonOpen] = useState(true);
    const rawDate = props?.showAppoinmentData?.slot?.date;



  const { useBreakpoint } = Grid;
    const screens = useBreakpoint();

//   functions
function appointmentForm() {
}
// const [buttonopen ,setButtonOpen]=useState(true)

  useEffect(() => {
    setButtonOpen(true)
  },[props?.hide])

let tempDataForDuration = [];
  // useEffect(() => {
  // console.log('::::::useEffect:::::', props.showAppoinmentData.duration)
  if (props.showAppoinmentData && props.showAppoinmentData.duration) {
    tempDataForDuration.push({
      key: "Duration",
      data:
        props.data &&
        props.data.durationObjectById &&
        props.showAppoinmentData.duration &&
        props.data.durationObjectById[props.showAppoinmentData.duration]
          ? props.data.durationObjectById[props.showAppoinmentData.duration]
              .duration + " minutes"
          : "15 minutes",
    });
  }

  if (props.showAppoinmentData && props.showAppoinmentData.price) {
    tempDataForDuration.push({
      key: "Price",
      data: props.showAppoinmentData.price
        ? capitalizeFirst(props.showAppoinmentData.price)
        : "",
    });
  }
  if (props.showAppoinmentData && props?.newData?.price) {
    tempDataForDuration.push({
      key: "Price",
      data: props.newData.price
        ? capitalizeFirst(props.newData.price)
        : "",
    });
  }
  if (props?.showAppoinmentData && props?.showAppoinmentData.language && props?.oldData?.encryptBookingDetails?.language_name  != null ) {
    let data = "";
    if (
      props.showAppoinmentData.language &&
      props.showAppoinmentData.language.value
    ) {
      data = props.showAppoinmentData.language.value;
    } else {
      data = props.showAppoinmentData.language;
    }
    // console.log('languageName dfd', props.data.languageData)
    let languageName = props.data.languageData.find(
      (landata) => landata.value == data
    );
    // console.log('languageName dfd',languageName)
    tempDataForDuration.push({
      key: "Language",
      data: languageName ? languageName.label : data,
    });
  }
  if (props?.showAppoinmentData && props?.showAppoinmentData?.gender  && props?.oldData?.encryptBookingDetails?.preferred_gender  != null ) {
    tempDataForDuration.push({
      key: "Gender",
      data: props.showAppoinmentData.gender
        ? capitalizeFirst(props.showAppoinmentData.gender)
        : "",
    });
  }
  if (props?.showAppoinmentData && props.showAppoinmentData?.gender  && props?.oldData?.encryptBookingDetails?.preferred_gender  != null ) {
    tempDataForDuration.push({
      key: "Gender",
      data: props.showAppoinmentData.gender
        ? capitalizeFirst(props.showAppoinmentData.gender)
        : "",
    });
  }
  


    function getProductName(id) {
    let products;
  
    // Try to load from localStorage and parse to object
    const stored = localStorage.getItem('nongroupproductid');
    if (stored) {
      try {
        products = JSON.parse(stored); // parse string to object
      } catch (e) {
        console.error("Invalid JSON in localStorage");
        products = {}; // fallback to empty object on error
      }
    } else {
      // Fallback if nothing in localStorage
      products = {
        201: "Vital",
        202: "Bronze",
        203: "Silver",
        204: "Gold",
        205: "Platinum",
        4: "Vital (15 minutes)",
        5: "Bronze (60 minutes)",
        6: "Gold (90 minutes)",
        7: "Silver (75min)",
        10: "Platinum",
        18: "r888",
        20: "r888178",
        22: "Diamond"
      };
    }
  
    // console.log("productsproductsproducts", products, typeof products);
    return products[id];
  }

  return (
    <>
      <div className="cancelPage" style={{ paddingTop:screens.md ?"30px":"0px" }}>

      <div style={{width:"-webkit-fill-available"}}>
        <div style={{
          // fontFamily:"Lato",
          fontWeight:"400",fontSize:"20px", color:"#008385",backgroundColor:"rgba(0, 131, 133, 0.25)",paddingLeft:"8px",height:"44px",display:"flex",justifyContent:screens.md ? "center" : "flex-start" ,alignItems:"center",maxWidth:screens.md ?"605px":"100vw"}}>Original booking: </div>
        {/* Appointment data duration language gender price  */}
        <div style={{ display: "grid", justifyContent: "center", }}>
          <div
            className="widthSet"
            style={{
              // maxWidth: "440px",
              background: "#F0FAFA",
              padding:screens.md ? "10px" : "0px",
              marginTop: 40,
              border: "1px solid #008385",
              // height: 61,
            }}
          >
            <span style={{ margin: 0, fontSize: 14, color: "#008385" }}>
              {props?.showAppoinmentData &&
              props?.showAppoinmentData.clinic &&
              props?.showAppoinmentData.clinic?.productCategory &&
              props?.showAppoinmentData.clinic?.productCategory?.title
                ? props?.showAppoinmentData.clinic?.productCategory?.title
                : "General GP consultation"}
            </span>


            {props?.showAppoinmentData &&
              props?.showAppoinmentData.clinic &&
              props?.showAppoinmentData.clinic?.productCategory &&
              props?.showAppoinmentData.clinic?.productCategory
                ?.product_category_id == 2 && <br />}


            
            <br />
            {/* {tempDataForDuration && tempDataForDuration?.length ? (
              <>
                {[0, 2].map((startIdx) => (
                  <div key={startIdx}>
                    {tempoldData
                      .slice(startIdx, startIdx + 2)
                      .map((rs, i, arr) => (
                        <React.Fragment key={i}>
                          <span style={{ color: "#000", fontSize: 13 }}>
                            {rs.key}:
                          </span>
                          <span style={{ fontSize: 13, color: "#008385" }}>
                            {" "}
                            {rs.data}
                            <span style={{ color: "#000" }}>
                              {i !== arr.length - 1 ? " | " : ""}
                            </span>
                          </span>
                        </React.Fragment>
                      ))}
                  </div>
                ))}
              </>
            ) : null} */}

{
  // 1. Grab clinic data once
  (() => {
    const clinic = props?.showAppoinmentData?.clinic;
    const nonGpId = clinic?.productCategory?.non_gp_product_id ;
    const productCategoryId = clinic?.productCategory?.product_category_id;

    // 2. If no non-gp product, render tempDataForDuration
    if (productCategoryId != 2 ) {
      if (tempDataForDuration?.length) {
        return (
          <>
            {[0, 2].map(startIdx => (
              <div key={startIdx}>
                {tempDataForDuration
                  .slice(startIdx, startIdx + 2)
                  .map((rs, i, arr) => (
                    <React.Fragment key={i}>
                      <span style={{ color: "#000", fontSize: 13 }}>
                        {rs.key}:
                      </span>
                      <span style={{ fontSize: 13, color: "#008385" }}>
                        {" "}{rs.data}
                        <span style={{ color: "#000" }}>
                          {i !== arr.length - 1 ? " | " : ""}
                        </span>
                      </span>
                    </React.Fragment>
                  ))}
              </div>
            ))}
          </>
        );
      }
      return null;
    }

    // 3. Else if product_category_id === 2, render product & price
    if (productCategoryId === 2) {
      return (
        <span style={{ color: "#008385", fontSize: 13 }}>
          {getProductName(nonGpId)} {" | "}
          {`Price: ${props?.oldData?.price}`}
        </span>
      );
    }

    // 4. Otherwise, render nothing
    return null;
  })()
}


            
          </div>
          {/* Date section */}
          <div
            className="widthSet"
            style={{
              // maxWidth: "440px",
              background: "#F0FAFA",
              padding:screens.md ? "10px" : "0px",
              border: "1px solid #008385",
              borderTop: "0",
              height: 61,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 0,
            }}
          >
            <span
              style={{
                margin: "auto",
                fontWeight: "500",
                fontSize: 20,
                color: "rgba(74, 74, 74, 1)",
              }}
            >
              {props?.oldData &&
              props?.oldData.date &&
              // props.showAppoinmentData.slot?.date
              //   ? moment(`${props.showAppoinmentData.slot?.date} 2025`).format(
              //       "D MMMM, YYYY"
              //     )
              //   : ""}{" "}
              // |{" "}
              props?.oldData &&
              props?.oldData.date &&
              props.oldData?.date
                ? moment(props.oldData?.date).format(
                    "D MMMM, YYYY"
                  )
                : ""}
               {" | "}
              {props?.oldData &&
              props?.oldData.time &&
              props.oldData?.time &&
              props.oldData?.time
                ? props.oldData?.time

                : "helloo"}
            </span>
          </div>
          <div
            style={{
              maxWidth: "394px",
              display: "flex",
              justifyContent: "flex-start",
              marginTop: 20,
              marginLeft: "10px",
            }}
          >
            <div
              style={{
                width: 90,
                height: 90,
                borderRadius: "10px",
                marginLeft: 1,
                paddingLeft:screens.md ? 0 : 10
              }}
            >
              <ClinicMap
                widthAndheight={{ width: 76, height: 76 }}
                passData={{
                  cood: [
                    {
                      id: props.oldData?.clinic?.id,
                      name: props.oldData?.clinic?.name,
                      data: [
                        props.oldData?.clinic?.lat || props?.oldData?.clinic?.latitude ||
                          "51.5072",
                        props.oldData?.clinic?.lng || props?.oldData?.clinic?.longitude ||
                          "0.1276",
                      ],
                    },
                  ],
                }}
              />
            </div>
            <div style={{ textAlign: "left", marginLeft: 30 }}>
              <p style={{ fontSize: 14 }}>
                {props?.oldData?.clinic?.name
                  ? props.oldData?.clinic?.name
                  : ""}
              </p>
              <p style={{ fontSize: 14 }}>
                {props?.oldData?.clinic?.address
                  ? props.oldData?.clinic?.address
                  : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* NewBooking */}
      <div style={{width:"-webkit-fill-available"}}>
         <div style={{
          // fontFamily:"Lato",
          fontWeight:"400",fontSize:"20px", color:"#008385",backgroundColor:"rgba(0, 131, 133, 0.25)",paddingLeft:"8px",height:"44px",display:"flex",justifyContent:screens.md ? "center" : "flex-start",alignItems:"center" ,maxWidth:screens.md ?"605px":"100vw"}}>New booking:</div>
        {/* Appointment data duration language gender price  */}
        <div style={{ display: "grid", justifyContent: "center", }}>
          <div
            className="widthSet"
            style={{
              // maxWidth: "440px",
              background: "#F0FAFA",
              padding:screens.md ? "10px" : "0px",
              marginTop: 40,
              border: "1px solid #008385",
              // height: 61,
            }}
          >
            <span style={{ margin: 0, fontSize: 14, color: "#008385" }}>
              {" "}
              {props?.showAppoinmentData &&
              props?.showAppoinmentData.clinic &&
              props?.showAppoinmentData.clinic?.productCategory &&
              props?.showAppoinmentData.clinic?.productCategory?.title
                ? props?.showAppoinmentData.clinic?.productCategory?.title
                : "General GP consultation"}
            </span>
            {props?.showAppoinmentData &&
              props?.showAppoinmentData.clinic &&
              props?.showAppoinmentData.clinic?.productCategory &&
              props?.showAppoinmentData.clinic?.productCategory
                ?.product_category_id == 2 && <br />}
            {props?.showAppoinmentData &&
              props?.showAppoinmentData.clinic &&
              props?.showAppoinmentData.clinic?.productCategory &&
              props?.showAppoinmentData.clinic?.productCategory
                ?.product_category_id == 2 && (
                <span style={{ margin: 0, fontSize: 14, color: "#008385" }}>
                  {" "}
                  {props?.showAppoinmentData &&
                  props?.showAppoinmentData.clinic &&
                  props?.showAppoinmentData.clinic?.productCategory &&
                  props?.showAppoinmentData.clinic?.productCategory
                    ?.product_category_id == 2 &&
                  props?.showAppoinmentData.clinic.non_gp_product_id &&
                  props.getAllHealthScreenData &&
                  props.getAllHealthScreenData.getAllHealthScreenData.data
                    ? filterByNonGpProductId(
                        props.getAllHealthScreenData.getAllHealthScreenData
                          .data,
                        props?.showAppoinmentData.clinic.non_gp_product_id
                      )?.length &&
                      filterByNonGpProductId(
                        props.getAllHealthScreenData.getAllHealthScreenData
                          .data,
                        props?.showAppoinmentData.clinic.non_gp_product_id
                      )[0].name
                    : ""}
                </span>
              )}
            <br />
            {/* {!props?.showAppoinmentData?.clinic?.non_gp_product_id ? (
            tempDataForDuration && tempDataForDuration?.length ? (
              <>
                {[0, 2].map((startIdx) => (
                  <div key={startIdx}>
                    {tempDataForDuration
                      .slice(startIdx, startIdx + 2)
                      .map((rs, i, arr) => (
                        <React.Fragment key={i}>
                          <span style={{ color: "#000", fontSize: 13 }}>
                            {rs.key}:
                          </span>
                          <span style={{ fontSize: 13, color: "#008385" }}>
                            {" "}
                            {rs.data}
                            <span style={{ color: "#000" }}>
                              {i !== arr.length - 1 ? " | " : ""}
                            </span>
                          </span>
                        </React.Fragment>
                      ))}
                  </div>
                ))}
              </>
            ) : null
          ) : (
            props?.showAppoinmentData.clinic?.productCategory
              ?.product_category_id  == 2 ? (
                <span style={{ color: "#008385", fontSize: 13 }}>
                  {getProductName(props?.showAppoinmentData?.clinic?.non_gp_product_id)} {" | "}
                  {`Price: ${props?.showAppoinmentData?.price} `}
                </span>                
              ) : ( null)

          )} */}


{
  // 1. Grab clinic data once
  (() => {
    const clinic = props?.showAppoinmentData?.clinic;
    const nonGpId = clinic?.productCategory?.non_gp_product_id ;
    const productCategoryId = clinic?.productCategory?.product_category_id;

    // 2. If no non-gp product, render tempDataForDuration
    if (productCategoryId != 2 ) {
      if (tempDataForDuration?.length) {
        return (
          <>
            {[0, 2].map(startIdx => (
              <div key={startIdx}>
                {tempDataForDuration
                  .slice(startIdx, startIdx + 2)
                  .map((rs, i, arr) => (
                    <React.Fragment key={i}>
                      <span style={{ color: "#000", fontSize: 13 }}>
                        {rs.key}:
                      </span>
                      <span style={{ fontSize: 13, color: "#008385" }}>
                        {" "}{rs.data}
                        <span style={{ color: "#000" }}>
                          {i !== arr.length - 1 ? " | " : ""}
                        </span>
                      </span>
                    </React.Fragment>
                  ))}
              </div>
            ))}
          </>
        );
      }
      return null;
    }

    // 3. Else if product_category_id === 2, render product & price
    if (productCategoryId === 2) {
      return (
        <span style={{ color: "#008385", fontSize: 13 }}>
          {getProductName(nonGpId)} {" | "}
          {`Price: ${props?.showAppoinmentData?.price}`}
        </span>
      );
    }

    // 4. Otherwise, render nothing
    return null;
  })()
}
          </div>
          {/* Date section */}
          <div
            className="widthSet"
            style={{
              // maxWidth: "440px",
              background: "#F0FAFA",
              padding:screens.md ? "10px" : "0px",
              border: "1px solid #008385",
              borderTop: "0",
              height: 61,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop:"0px"
            }}
          >
            <span
              style={{
                margin: "auto",
                fontWeight: "500",
                fontSize: 20,
                color: "rgba(74, 74, 74, 1)",
              }}
            >
              {props?.showAppoinmentData &&
              props?.showAppoinmentData.slot &&
              // props.showAppoinmentData.slot?.date
              //   ? moment(`${props.showAppoinmentData.slot?.date} 2025`).format(
              //       "D MMMM, YYYY"
              //     )
              //   : ""}{" "}
              // |{" "}
              props?.showAppoinmentData &&
              props?.showAppoinmentData.slot &&
              props.showAppoinmentData.slot?.date
                // ? moment(props.showAppoinmentData.slot?.date).format("D MMMM, YYYY")
                ? rawDate
                : ""}
              {props?.showAppoinmentData &&
              props?.showAppoinmentData.slot &&
              props.showAppoinmentData?.slot?.info &&
              props.showAppoinmentData?.slot?.info?.start_time
                ? " | "+ props.showAppoinmentData?.slot?.info?.start_time
                : ""}
            </span>
          </div>
          <div
            style={{
              maxWidth: "394px",
              display: "flex",
              justifyContent: "flex-start",
              marginTop: 20,
              marginLeft: "10px",
            }}
          >
            <div
              style={{
                width: 90,
                height: 90,
                borderRadius: "10px",
                marginLeft: 1,
              }}
            >
              <ClinicMap
                widthAndheight={{ width: 76, height: 76 }}
                passData={{
                  cood: [
                    {
                      id: props.showAppoinmentData?.slot?.clinicData?.id,
                      name: props.showAppoinmentData?.slot?.clinicData?.name,
                      data: [
                        props.showAppoinmentData?.slot?.clinicData?.latitude ||
                          "51.5072",
                        props.showAppoinmentData?.slot?.clinicData?.longitude ||
                          "0.1276",
                      ],
                    },
                  ],
                }}
              />
            </div>
            <div style={{ textAlign: "left", marginLeft: 30 }}>
              <p style={{ fontSize: 14 }}>
                {props.showAppoinmentData?.slot?.clinicData?.name
                  ? props.showAppoinmentData.slot.clinicData.name
                  : ""}
              </p>
              <p style={{ fontSize: 14 }}>
                {props.showAppoinmentData?.slot?.clinicData?.address
                  ? props.showAppoinmentData?.slot?.clinicData?.address
                  : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
     {buttonopen && (
  buttonopen ? (
    <div className="bottem">
      <div className="bottomButtons" style={{ alignItems: "center" }}>
        { buttonopen?
                <div
                  style={{ display: "flex", justifyContent: "center", marginTop: 5}}
                >
                  <Button
                    shape="square"
                    icon={
                      <ArrowLeftOutlined
                        // onClick={props.callBackForbackpage("booking")}
                        style={{ color: "#008385", fontSize: "18px" }}
                      />
                    }
                    style={{
                      backgroundColor: "#C8E6E6", // Light teal
                      border: "none",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: 0,
                      marginRight: 10,
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      position:"absolute",
                      left:"10px"
                    }}
                    onClick={() =>{
                      // console.log("hello from button")
                      props?.callBackForbackpage(
                        props?.showAppoinmentData?.type
                          ? props?.showAppoinmentData?.type
                          : "BookingForm"
                      )
                    }
                    }
                  />
                </div>:""}
        <Button
          className="transparentBtn"
          // onClick={() => appointmentForm("PreferredTimeclinic")}
          onClick={()=>window.location.reload()}
          style={{height:"30px",width:"283px"}}
        >
          <div style={{display:"flex",flexDirection:screens.md?"row": "column",justifyContent:"center",alignItems:"center",gap:screens.md?"7px":"0px"}}>
                                            <span> {capitalizeWords("Keep original ")}</span>
                                            <span>{capitalizeWords(" appointment")}</span>
                                            </div>
          {/* {capitalizeWords("Keep original appointment")} */}
        </Button>
        <Button
          // className="darkBtn"
          className="transparentBtn"
          style={{ height:"30px",width:"283px",margin:"auto" }}
          onClick={() => {
            props.callback({ nexData: "data" }, "BookingDetailsNext");
            setButtonOpen(!buttonopen);
          }}
        >
          <div style={{display:"flex",flexDirection:screens.md?"row": "column",justifyContent:"center",alignItems:"center",gap:screens.md?"7px":"0px"}}>
                                            <span> {capitalizeWords("Confirm new ")}</span>
                                            <span>{capitalizeWords(" appointment")}</span>
                                            </div>
          {/* {capitalizeWords("Confirm new appointment")} */}
        </Button>
      </div>
    </div>
  ) : null
)}

    
    </>
  );
}

export default CancelationBookingDetails;
